import { type ImageInterface } from 'Image/types';
import { modifyHref } from 'NavigationHelpers';

// FIXME: this should probably be called something like modifyImageUrlForFormat at this
// point, since it doesn't just do region-aware stuff
export const regionAwareImageUrlForFormat = (image: ImageInterface, format: string) =>
    image?.formats?.[format] && modifyHref(image.formats[format].url);

export default regionAwareImageUrlForFormat;
